<script>
import Calendar from 'vue2-slot-calendar'
import {cloneDeep} from 'lodash-es'
import {format as dateFormat, isValid as dateIsValid, parse as dateParse} from 'date-fns'
import {ja as dateLocale} from 'date-fns/locale'

// 日本語対応
const langTextDefault = Object.freeze({
  daysOfWeek:  ['日', '月', '火', '水', '木', '金', '土'],
  limit:       'Limit reached ({{limit}} items max).',
  loading:     'ロード中...',
  minLength:   'Min. Length',
  months:      ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
  notSelected: '未選択',
  required:    '必須',
  search:      '検索',
})

export default {
  extends: Calendar,

  props: {
    format: {default: 'yyyy年M月d日(E)'},
  },

  mounted() {
    // emit blur event
    this._ex_input = this.$el.querySelector('input')
    this._ex_blur = e => {this.$emit('blur', e)}
    this._ex_input.addEventListener('blur', this._ex_blur)
  },

  beforeDestroy() {
    // emit blur event
    this._ex_input.removeEventListener('blur', this._ex_blur)
  },

  methods: {
    // 日本語対応
    translations(lang) {
      return cloneDeep(langTextDefault)
    },

    // カレンダーのヘッダ
    stringifyDayHeader(date, month = 0) {
      const d = this.siblingsMonth(date, month)
      return d.getFullYear() + '年' + this.text.months[d.getMonth()]
    },

    // 日付フォーマット取り扱いの改善
    stringify(date, format = this.dateFormat) {
      return dateFormat(date, format, {locale: dateLocale})
    },

    parse(str, safe = true) {
      if(str) {
        const match = str.match(/\d+/g)
        if(match) {
          const exstr = match.join('/')
          const exfmt = this.dateFormat.match(/[yMd]+/g)
          while(0 < exfmt.length) {
            const date = dateParse(exstr, exfmt.join('/'), new Date())
            if(dateIsValid(date)) return date
            exfmt.pop()
          }
        }
      }

      // 親コンポーネントを呼び出す
      return Calendar.methods.parse.call(this, str, safe)
    },
  },
}
</script>
